<template>
  <div class="va-row">
    <div class="flex md12">
      <vuestic-widget :headerText="'customer.create_type_title' | translate">
        <form @submit.prevent="createType">
          <div class="va-row">
            <div class="flex md6">
              <div class="form-group">
                <div class="input-group">
                  <input id="simple-input" required v-model="customerType">
                  <label
                    class="control-label"
                    for="simple-input"
                  >{{'customer.fields.type'| translate}}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
            <div class="flex md6">
              <div class="form-group">
                <div class="input-group">
                  <textarea
                    id="simple-input_desc"
                    required
                    v-model="customerTypeDescription"
                    cols="30"
                    rows="3"
                  ></textarea>
                  <label
                    class="control-label"
                    for="simple-input_desc"
                  >{{'customer.fields.desc'| translate}}</label>
                  <i class="bar"></i>
                </div>
              </div>
            </div>
            <div class="flex md6 align--center">
              <vuestic-checkbox :label="$t('customer.fields.can_create')" v-model="canCreate"/>
            </div>
          </div>
          <div class="va-row justify--center">
            <button class="btn btn-primary btn-with-icon">
              <div class="btn-with-icon-content">
                <i class="ion-md-add ion"></i>
                {{'buttons.create' | translate}}
              </div>
            </button>
          </div>
          <div class="va-row"></div>
        </form>
      </vuestic-widget>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CreateType',
  data() {
    return {
      canCreate: false,
      customerType: '',
      customerTypeDescription: ''
    }
  },
  created() {
    this.$nextTick(() => {
      this.$validator.validateAll()
    })
  },
  methods: {
    createType() {
      this.$store
        .dispatch('createCustomerType', {
          customerType: this.customerType,
          customerTypeDesc: this.customerTypeDescription,
          canCreate: this.canCreate
        })
        .then(() => {
          this.$toasted.show('Customer Type Added', {
            icon: 'fa-star-o',
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
          this.$router.push({ path: 'dashboard' })
        })
        .catch(() => {
          this.$toasted.show('SomeThing Went Wrong', {
            icon: 'fa-star-o',
            position: 'top-right',
            duration: 5000,
            fullWidth: false
          })
        })
    }
  }
}
</script>
